var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Accordion, Row, Col } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { Controller, useFormContext } from "react-hook-form";
import { RecekOnixItemPicker, RecekTextField } from "../inputs";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { PARTIAL_DATE_PLACEHOLDER } from "../../utils/dateUtils";
export var ProductDetailsSection = function (_a) {
    var open = _a.open, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    var control = useFormContext().control;
    var _b = useOnixOptions(), compositionTable = _b.compositionTable, publishingStatusTable = _b.publishingStatusTable, compositionStatus = _b.compositionStatus, publishingStatusStatus = _b.publishingStatusStatus;
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.product.accordion.product",
        }), open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "composition", render: function (_a) {
                        var _b, _c;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.product.composition.field.label", dataOptions: (_b = compositionTable === null || compositionTable === void 0 ? void 0 : compositionTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [], codetableStatus: compositionStatus, value: field.value, onChange: field.onChange, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true }));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "publishingStatus", render: function (_a) {
                        var _b, _c;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.product.publishingStatus.field.label", dataOptions: (_b = publishingStatusTable === null || publishingStatusTable === void 0 ? void 0 : publishingStatusTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [], codetableStatus: publishingStatusStatus, value: field.value, onChange: field.onChange, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true }));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Controller, { control: control, name: "publishingDate", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.product.publishingDate.field.label", placeholder: PARTIAL_DATE_PLACEHOLDER, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "copyrightFrom", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.product.copyrightFrom.field.label", placeholder: PARTIAL_DATE_PLACEHOLDER, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "copyrightTo", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.product.copyrightTo.field.label", placeholder: PARTIAL_DATE_PLACEHOLDER, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } })))));
};
